<template>
  <div class="employer-history-list">
    <el-form :inline="true" size="small" class="toolbar">
      <el-form-item label="被保险人"><el-input v-model.trim="search.policyholder" clearable placeholder="被保险人" style="width:200px" /></el-form-item>
      <el-form-item label="保单号"><el-input v-model.trim="search.policyNo" clearable placeholder="保单号" style="width:200px" /></el-form-item>
      <el-form-item label="手机号"><el-input v-model.trim="search.mobile" clearable placeholder="手机号" style="width:160px" /></el-form-item>
      <el-form-item label="变更时间"><el-date-picker v-model="search.changeDateRange" type="daterange" value-format="timestamp" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" /></el-form-item>
      <el-form-item label="生效时间"><el-date-picker v-model="search.effectDateRange" type="daterange" value-format="timestamp" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" /></el-form-item>
      <el-form-item label="变更类型"><el-select v-model="search.type" clearable placeholder="变更类型"><el-option label="换人" :value="1"/><el-option label="加人" :value="2"/><el-option label="退保" :value="4"/></el-select></el-form-item>
      <el-form-item label="变更状态"><el-select v-model="search.status" clearable placeholder="变更状态"><el-option label="未通过" :value="1"/><el-option label="已通过" :value="4"/><el-option label="已作废" :value="16"/></el-select></el-form-item>
      <el-form-item label="保险公司"><el-select v-model="search.insuranceTypes" multiple filterable clearable placeholder="保险公司" style="width:280px"><el-option v-for="o in insuranceOptions" :key="o.id" :label="o.name" :value="Number(o.id)"/></el-select></el-form-item>
      <el-form-item label="录入保司"><el-select v-model="search.isInput" clearable placeholder="是否录入"><el-option label="已录入" :value="1"/><el-option label="未录入" :value="2"/></el-select></el-form-item>
      <el-form-item label="来源"><el-select v-model="search.source" clearable placeholder="来源"><el-option v-for="o in sourceOptions" :key="o.value" :label="o.label" :value="o.value"/></el-select></el-form-item>
      <el-form-item label="变更批号"><el-input v-model.trim="search.groupNo" clearable placeholder="变更批号" /></el-form-item>
      <el-form-item label="发票状态"><el-select v-model="search.invoiceReceived" clearable><el-option label="已收到" value="true"/><el-option label="未收到" value="false"/></el-select></el-form-item>
      <el-form-item label="是否标红"><el-select v-model="search.highlight" clearable><el-option label="已标红" value="true"/><el-option label="未标红" value="false"/></el-select></el-form-item>
      <el-form-item label="开票类型"><el-select v-model="search.invoiceType" clearable placeholder="开票类型"><el-option label="开票" :value="1"/><el-option label="不开票" :value="2"/><el-option label="待定" :value="4"/><el-option label="普票" :value="8"/><el-option label="专票" :value="16"/></el-select></el-form-item>
      <el-form-item label="标注颜色"><el-select v-model="search.markColour" clearable placeholder="标注颜色"><el-option label="柠檬黄" :value="1"/><el-option label="淡绿色" :value="2"/><el-option label="浅灰色" :value="4"/></el-select></el-form-item>
      <el-form-item label="渠道"
        ><el-select
          v-model="channelId"
          filterable
          clearable
          placeholder="全部渠道"
          style="width:220px"
          ><el-option
            v-for="o in channelOptions"
            :key="o.id"
            :label="channelLabel(o)"
            :value="Number(o.id)"/></el-select
      ></el-form-item>
      <el-form-item
        ><el-button type="primary" icon="el-icon-search" @click="search"
          >搜索</el-button
        ><el-button icon="el-icon-refresh" @click="reset">重置</el-button
        ><el-button type="success" icon="el-icon-download" @click="exportExcel"
          >导出 Excel</el-button
        ></el-form-item
      >
    </el-form>
    <el-table
      :data="rows"
      border
      stripe
      v-loading="loading"
      height="calc(100vh - 255px)"
      :row-class-name="rowClassName"
    >
      <el-table-column
        prop="company_name"
        label="投保公司"
        width="190"
        fixed="left"
        show-overflow-tooltip
      />
      <el-table-column prop="policy_no" label="保单号" width="180" />
      <el-table-column label="变更时间" width="165"
        ><template slot-scope="s">{{
          date(s.row.created_at)
        }}</template></el-table-column
      >
      <el-table-column label="生效时间" width="165"
        ><template slot-scope="s">{{
          date(Number(s.row.type) === 4 ? s.row.expire_date : s.row.effect_date)
        }}</template></el-table-column
      >
      <el-table-column prop="product_type_name" label="产品类型" width="150" />
      <el-table-column label="变更类型" width="90"
        ><template slot-scope="s">{{
          typeText(s.row.type)
        }}</template></el-table-column
      >
      <el-table-column label="金额(元)" width="110" align="right"
        ><template slot-scope="s">{{
          money(s.row.total_add_price)
        }}</template></el-table-column
      >
      <el-table-column
        prop="remarks"
        label="备注信息"
        width="150"
        show-overflow-tooltip
      />
      <el-table-column label="变更前人员" width="310"
        ><template slot-scope="s"
          ><employee-lines :value="s.row.old_employees" old/></template
      ></el-table-column>
      <el-table-column label="变更后/加人人员" width="380"
        ><template slot-scope="s"
          ><employee-lines :value="s.row.new_employees"/></template
      ></el-table-column>
      <el-table-column label="支付凭证" width="100"
        ><template slot-scope="s"
          ><file-links :value="s.row.pay_voucher_url"/></template
      ></el-table-column>
      <el-table-column label="批改申请" width="100"
        ><template slot-scope="s"
          ><file-links :value="s.row.correct_url"/></template
      ></el-table-column>
      <el-table-column label="上传凭证时间" width="165"
        ><template slot-scope="s">{{
          date(s.row.upload_pay_voucher_time)
        }}</template></el-table-column
      >
      <el-table-column
        prop="policy_channel"
        label="渠道"
        width="150"
        show-overflow-tooltip
      />
      <el-table-column label="批单" width="110"
        ><template slot-scope="s"
          ><a
            v-if="s.row.endorsement_url"
            :href="s.row.endorsement_url"
            target="_blank"
            >{{ s.row.endorsement_no || "查看" }}</a
          ><span v-else>-</span></template
        ></el-table-column
      >
      <el-table-column label="发票" width="110"
        ><template slot-scope="s"
          ><file-links
            v-if="isReceived(s.row)"
            :value="s.row.invoice_url"
            :empty-label="'已收到'"
          /><span v-else>未收到</span></template
        ></el-table-column
      >
      <el-table-column label="开票类型" width="100"
        ><template slot-scope="s">{{
          invoiceType(s.row)
        }}</template></el-table-column
      >
      <el-table-column
        prop="special_work_remark"
        label="特殊工种备注"
        width="150"
        show-overflow-tooltip
      />
      <el-table-column prop="mobile" label="手机号" width="120" />
      <el-table-column prop="group_no" label="变更批号" width="150" />
      <el-table-column label="来源" width="130"
        ><template slot-scope="s">{{
          sourceText(s.row.source)
        }}</template></el-table-column
      >
      <el-table-column label="保险公司" width="220" show-overflow-tooltip
        ><template slot-scope="s">{{
          insuranceText(s.row)
        }}</template></el-table-column
      >
      <el-table-column
        prop="note"
        label="备注"
        width="120"
        show-overflow-tooltip
      />
      <el-table-column label="操作" width="520">
        <template slot-scope="s">
          <template v-if="!s.row.deleted_at">
            <el-button
              v-if="Number(s.row.status) === 1"
              type="text"
              @click="confirm(s.row)"
              >确认通过</el-button
            ><span v-else class="muted">已通过</span>
            <el-button
              type="text"
              :disabled="!canEmail(s.row)"
              @click="sendEmail(s.row)"
              >{{ s.row.is_emailed ? "再次发送" : "发送邮件" }}</el-button
            >
            <el-button type="text" @click="openFile(s.row, 'pg')"
              >上传批改申请</el-button
            >
            <el-button
              v-if="Number(s.row.type) === 2"
              type="text"
              @click="openFile(s.row, 'pz')"
              >上传支付凭证</el-button
            >
            <el-button
              v-if="Number(s.row.status) === 4"
              type="text"
              @click="openFile(s.row, 'pd')"
              >上传批单</el-button
            ><el-button
              v-else
              type="text"
              class="danger"
              @click="voidHistory(s.row)"
              >作废</el-button
            >
          </template>
          <el-button type="text" @click="openNote(s.row)">备注</el-button>
          <template
            v-if="Number(s.row.type) === 2 && Number(s.row.status) === 4"
            ><el-button type="text" @click="toggleInvoice(s.row)">{{
              isReceived(s.row) ? "取消收到发票" : "已收到发票"
            }}</el-button></template
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="pagination"
      :current-page="page"
      :page-size="pageSize"
      :page-sizes="[10, 15, 20, 25]"
      :total="total"
      layout="total, sizes, prev, pager, next, jumper"
      @size-change="changeSize"
      @current-change="changePage"
    />

    <history-confirm-dialog
      :visible.sync="confirmVisible"
      :row="currentRow"
      @success="fetchData"
    />
    <history-file-dialog
      :visible.sync="fileVisible"
      :row="currentRow"
      :file-type="fileType"
      @success="fetchData"
    />
    <el-dialog
      title="查看明细"
      :visible.sync="detailVisible"
      width="760px"
      append-to-body
      ><el-table :data="detailRows" border
        ><el-table-column label="金额" prop="amount"
          ><template slot-scope="s">{{
            money(s.row.amount)
          }}</template></el-table-column
        ><el-table-column label="原金额" prop="old_add_price"
          ><template slot-scope="s">{{
            money(s.row.old_add_price)
          }}</template></el-table-column
        ><el-table-column label="应付金额" prop="payable_amount"
          ><template slot-scope="s">{{
            money(s.row.payable_amount)
          }}</template></el-table-column
        ><el-table-column label="实付金额" prop="actual_amount"
          ><template slot-scope="s">{{
            money(s.row.actual_amount)
          }}</template></el-table-column
        ><el-table-column label="挂账金额" prop="credit_amount"
          ><template slot-scope="s">{{
            money(s.row.credit_amount)
          }}</template></el-table-column
        ><el-table-column prop="note" label="备注"/></el-table
    ></el-dialog>
    <el-dialog
      title="修改备注"
      :visible.sync="noteVisible"
      width="480px"
      append-to-body
      ><el-input v-model="noteValue" type="textarea" :rows="5" /><span
        slot="footer"
        ><el-button @click="noteVisible = false">取消</el-button
        ><el-button type="primary" @click="saveNote">保存</el-button></span
      ></el-dialog
    >
    <el-dialog
      title="标注颜色"
      :visible.sync="colourVisible"
      width="480px"
      append-to-body
      ><el-radio-group v-model="colourValue"
        ><el-radio :label="1">柠檬黄</el-radio
        ><el-radio :label="2">淡绿色</el-radio
        ><el-radio :label="4">浅灰色</el-radio></el-radio-group
      ><span slot="footer"
        ><el-button @click="saveColour(0)">取消标注</el-button
        ><el-button @click="colourVisible = false">关闭</el-button
        ><el-button type="primary" @click="saveColour(colourValue)"
          >保存</el-button
        ></span
      ></el-dialog
    >
    <el-dialog
      title="已收到发票"
      :visible.sync="invoiceVisible"
      width="560px"
      append-to-body
      ><el-radio-group v-model="invoiceMode"
        ><el-radio :label="1">已收到纸质发票</el-radio
        ><el-radio :label="2">上传电子发票</el-radio></el-radio-group
      ><employer-file-upload
        v-if="invoiceMode === 2"
        v-model="invoiceUrls"
        multiple
        class="invoice-upload"
      /><span slot="footer"
        ><el-button @click="invoiceVisible = false">取消</el-button
        ><el-button type="primary" @click="saveInvoice">保存</el-button></span
      ></el-dialog
    >
  </div>
</template>

<script>
import dayjs from "dayjs";
import ExportJsonExcel from "js-export-excel";
import {
  deleteEmployerHistory,
  exportEmployerHistoryList,
  getEmployerChannels,
  getEmployerHistoryAmountList,
  getEmployerHistoryList,
  getEmployerInsuranceCompanies,
  sendEmployerHistoryEmail,
  updateEmployerHistoryColour,
  updateEmployerHistoryInvoice,
  updateEmployerHistoryNote
} from "@/api/employer-insurance";
import EmployerFileUpload from "./components/EmployerFileUpload.vue";
import HistoryConfirmDialog from "./components/HistoryConfirmDialog.vue";
import HistoryFileDialog from "./components/HistoryFileDialog.vue";
const parseUrls = value => {
  if (!value) return [];
  if (Array.isArray(value))
    return value
      .map(i => (typeof i === "string" ? i : i && i.url))
      .filter(Boolean);
  try {
    return parseUrls(JSON.parse(value));
  } catch (e) {
    return String(value)
      .split(",")
      .filter(Boolean);
  }
};
const workType = v =>
  ({ 1: "搬运工人", 2: "文员内勤", 4: "司机押运" }[Number(v)] || v || "-");
const FileLinks = {
  functional: true,
  props: {
    value: { type: [String, Array], default: "" },
    emptyLabel: { type: String, default: "-" }
  },
  render(h, c) {
    const urls = parseUrls(c.props.value);
    if (!urls.length) return h("span", c.props.emptyLabel);
    return h(
      "span",
      urls.map((u, i) =>
        h(
          "a",
          {
            key: u + i,
            attrs: { href: u, target: "_blank", rel: "noopener" },
            style: { marginRight: "8px" }
          },
          `文件${i + 1}`
        )
      )
    );
  }
};
const EmployeeLines = {
  functional: true,
  props: {
    value: { type: Array, default: () => [] },
    old: { type: Boolean, default: false }
  },
  render(h, c) {
    return h(
      "div",
      (c.props.value || []).map((e, i) =>
        h(
          "div",
          { key: i, class: e.is_highlight ? "employee-highlight" : "" },
          c.props.old
            ? `${workType(e.type)} - ${e.name} - ${e.idcard}`
            : `${workType(e.type)} - ${Number(e.unit_price || 0) /
                100}元 - ${Number(e.price_add || 0) / 100}元 - ${e.name} - ${
                e.idcard
              }`
        )
      )
    );
  }
};
export default {
  name: "EmployerHistoryList",
  components: {
    EmployerFileUpload,
    HistoryConfirmDialog,
    HistoryFileDialog,
    FileLinks,
    EmployeeLines
  },
  data() {
    return {
      loading: false,
      rows: [],
      page: 1,
      pageSize: 15,
      total: 0,
      search: {
        policyholder: "",
        policyNo: "",
        mobile: "",
        changeDateRange: [],
        effectDateRange: [],
        type: "",
        status: "",
        insuranceTypes: [],
        isInput: "",
        source: "",
        groupNo: "",
        invoiceReceived: "",
        highlight: "",
        invoiceType: "",
        markColour: ""
      },
      channelId: "",
      insuranceOptions: [],
      channelOptions: [],
      currentRow: {},
      confirmVisible: false,
      fileVisible: false,
      fileType: "pg",
      detailVisible: false,
      detailRows: [],
      noteVisible: false,
      noteValue: "",
      colourVisible: false,
      colourValue: 1,
      invoiceVisible: false,
      invoiceMode: 1,
      invoiceUrls: [],
      sourceOptions: [
        { value: 1, label: "PC浏览器端投保" },
        { value: 2, label: "移动浏览器端投保" },
        { value: 4, label: "iOS端投保" },
        { value: 8, label: "安卓端投保" },
        { value: 16, label: "API投保" },
        { value: 32, label: "微信小程序" },
        { value: 64, label: "渠道管理后台" },
        { value: 128, label: "内部管理后台" },
        { value: 256, label: "代理人H5" }
      ]
    };
  },
  created() {
    this.fetchData();
    this.loadOptions();
  },
  methods: {
    async loadOptions() {
      const [i, c] = await Promise.all([
        getEmployerInsuranceCompanies(),
        getEmployerChannels()
      ]);
      this.insuranceOptions = (i && (i.rows || i.data)) || [];
      this.channelOptions = (c && (c.rows || c.data)) || [];
    },
    buildParams(paging = true) {
      const p = { platform_type: 8 };
      if (paging) Object.assign(p, { page: this.page, rows: this.pageSize });
      const search = this.search;
      if (search.policyholder) p.policyholder = search.policyholder;
      if (search.policyNo) p.policy_no = search.policyNo;
      if (search.mobile) p.mobile = search.mobile;
      if (search.type !== "") p.type = search.type;
      if (search.insuranceTypes.length) p.insurance_type_list = `(${search.insuranceTypes.join(",")})`;
      if (search.status !== "") p.status = search.status;
      if (search.isInput !== "") p.is_input = Number(search.isInput) === 1 ? "true" : "false";
      if (search.source !== "") p.source = search.source;
      if (search.groupNo) p.group_no = search.groupNo;
      if (search.invoiceReceived !== "") p.is_invoice_received = search.invoiceReceived;
      if (search.highlight !== "") p.is_highlight = search.highlight;
      if (search.invoiceType !== "") p.vat_invoice_open_type = search.invoiceType;
      if (search.markColour !== "") p.mark_colour = search.markColour;
      if (search.changeDateRange.length === 2) {
        p.begin_date = Math.floor(search.changeDateRange[0] / 1000);
        p.end_date = Math.floor(search.changeDateRange[1] / 1000) + 86399;
      }
      if (search.effectDateRange.length === 2) {
        p.begin_effect = Math.floor(search.effectDateRange[0] / 1000);
        p.end_effect = Math.floor(search.effectDateRange[1] / 1000) + 86399;
      }
      if (this.channelId !== "") p.channel_id = this.channelId;
      return p;
    },
    async fetchData() {
      this.loading = true;
      try {
        const res = await getEmployerHistoryList(this.buildParams());
        this.rows = (res && res.rows) || [];
        this.total = Number((res && res.total) || this.rows.length);
      } finally {
        this.loading = false;
      }
    },
    search() {
      this.page = 1;
      this.fetchData();
    },
    reset() {
      this.channelId = "";
      this.search = {
        policyholder: "", policyNo: "", mobile: "", changeDateRange: [], effectDateRange: [],
        type: "", status: "", insuranceTypes: [], isInput: "", source: "", groupNo: "",
        invoiceReceived: "", highlight: "", invoiceType: "", markColour: ""
      };
      this.page = 1;
      this.fetchData();
    },
    changeSize(v) {
      this.pageSize = v;
      this.page = 1;
      this.fetchData();
    },
    changePage(v) {
      this.page = v;
      this.fetchData();
    },
    confirm(row) {
      this.currentRow = row;
      this.confirmVisible = true;
    },
    openFile(row, type) {
      this.currentRow = row;
      this.fileType = type;
      this.fileVisible = true;
    },
    canEmail(row) {
      return (
        Number(row.type) === 1 ||
        (Number(row.type) === 2 && !!row.pay_voucher_url)
      );
    },
    async sendEmail(row) {
      await this.$confirm("确定发送邮件吗？", "提示");
      const res = await sendEmployerHistoryEmail({ id: Number(row.id) });
      if (res) {
        this.$message.success("发送成功");
        this.fetchData();
      }
    },
    async voidHistory(row) {
      await this.$confirm("确定作废该变更记录吗？", "提示", {
        type: "warning"
      });
      const res = await deleteEmployerHistory({
        order_id: Number(row.order_id),
        group_no: String(row.group_no)
      });
      if (res) {
        this.$message.success("作废成功");
        this.fetchData();
      }
    },
    async showDetail(row) {
      this.currentRow = row;
      const res = await getEmployerHistoryAmountList({
        order_id: Number(row.order_id),
        group_no: row.group_no,
        type: 2
      });
      this.detailRows = (res && res.rows) || [];
      this.detailVisible = true;
    },
    openNote(row) {
      this.currentRow = row;
      this.noteValue = row.remarks || "";
      this.noteVisible = true;
    },
    async saveNote() {
      const res = await updateEmployerHistoryNote({
        order_id: Number(this.currentRow.order_id),
        group_no: this.currentRow.group_no,
        remarks: this.noteValue
      });
      if (res) {
        this.$message.success("保存成功");
        this.noteVisible = false;
        this.fetchData();
      }
    },
    openColour(row) {
      this.currentRow = row;
      this.colourValue = Number(row.mark_colour) || 1;
      this.colourVisible = true;
    },
    async saveColour(value) {
      const res = await updateEmployerHistoryColour({
        order_id: Number(this.currentRow.order_id),
        group_no: this.currentRow.group_no,
        mark_colour: Number(value)
      });
      if (res) {
        this.$message.success("保存成功");
        this.colourVisible = false;
        this.fetchData();
      }
    },
    async toggleInvoice(row) {
      this.currentRow = row;
      if (this.isReceived(row)) {
        await this.$confirm("确定取消收到发票吗？", "提示");
        const res = await updateEmployerHistoryInvoice({
          order_id: Number(row.order_id),
          group_no: row.group_no,
          is_invoice_received: false
        });
        if (res) {
          this.$message.success("修改成功");
          this.fetchData();
        }
      } else {
        this.invoiceMode = 1;
        this.invoiceUrls = [];
        this.invoiceVisible = true;
      }
    },
    async saveInvoice() {
      if (this.invoiceMode === 2 && !this.invoiceUrls.length) {
        this.$message.warning("请上传电子发票");
        return;
      }
      const res = await updateEmployerHistoryInvoice({
        order_id: Number(this.currentRow.order_id),
        group_no: this.currentRow.group_no,
        invoice_url: this.invoiceMode === 2 ? this.invoiceUrls : [],
        is_invoice_received: true
      });
      if (res) {
        this.$message.success("保存成功");
        this.invoiceVisible = false;
        this.fetchData();
      }
    },
    async exportExcel() {
      const filters = this.buildParams(false);
      if (Object.keys(filters).length < 2) {
        this.$message.warning("请先设置检索条件再导出");
        return;
      }
      const res = await exportEmployerHistoryList(filters);
      const list = (res && res.rows) || [];
      new ExportJsonExcel({
        fileName: "雇主险加人换人记录",
        datas: [
          {
            sheetName: "变更记录",
            sheetData: list.map(r => ({
              company_name: r.company_name,
              policy_no: r.policy_no,
              mobile: r.mobile,
              policy_channel: r.policy_channel,
              top_channel: r.top_channel,
              endorsement_no: r.endorsement_no,
              created_at: this.date(r.created_at),
              effect_date: this.date(
                Number(r.type) === 4 ? r.expire_date : r.effect_date
              ),
              type: this.typeText(r.type),
              is_invoice_received: this.isReceived(r) ? "已收到" : "未收到",
              vat_invoice_type: this.invoiceType(r),
              total_add_price: this.money(r.total_add_price),
              remarks: r.remarks,
              insurance: this.insuranceText(r),
              product_type_name: r.product_type_name,
              group_no: r.group_no
            })),
            sheetFilter: [
              "company_name",
              "policy_no",
              "mobile",
              "policy_channel",
              "top_channel",
              "endorsement_no",
              "created_at",
              "effect_date",
              "type",
              "is_invoice_received",
              "vat_invoice_type",
              "total_add_price",
              "remarks",
              "insurance",
              "product_type_name",
              "group_no"
            ],
            sheetHeader: [
              "投保公司",
              "保单号",
              "手机号",
              "渠道",
              "顶级渠道",
              "批单号",
              "变更时间",
              "生效时间",
              "变更类型",
              "是否收到发票",
              "开票类型",
              "金额",
              "备注",
              "保险公司",
              "产品类型",
              "变更批号"
            ]
          }
        ]
      }).saveExcel();
    },
    rowClassName({ row }) {
      if (row.deleted_at) return "row-disabled";
      if (!row.endorsement_url && row.is_highlight) return "row-highlight";
      if (row.credit_amount && !row.is_highlight && Number(row.status) === 1)
        return "row-credit";
      return `row-colour-${Number(row.mark_colour) || 0}`;
    },
    insuranceText(row) {
      if (row.insurance_company_name) return row.insurance_company_name;
      const option = this.insuranceOptions.find(
        item => String(item.id) === String(row.insurance_type)
      );
      return option ? option.name : row.insurance_type || "-";
    },
    typeText(v) {
      return { 1: "换人", 2: "加人", 4: "退保" }[Number(v)] || "-";
    },
    sourceText(v) {
      const o = this.sourceOptions.find(i => i.value === Number(v));
      return o ? o.label : "未知";
    },
    invoiceType(r) {
      if (Number(r.vat_invoice_open_type) === 2) return "不开票";
      if (Number(r.vat_invoice_open_type) !== 1) return "待定";
      return Number(r.vat_invoice_type) === 2 ? "专票" : "普票";
    },
    isReceived(r) {
      return (
        r.is_invoice_received === true ||
        String(r.is_invoice_received) === "true" ||
        Number(r.is_invoice_received) === 1
      );
    },
    date(v) {
      return v ? dayjs(v).format("YYYY-MM-DD HH:mm:ss") : "-";
    },
    money(v) {
      return v == null || v === "" ? "-" : (Number(v) / 100).toFixed(2);
    },
    channelLabel(o) {
      const n = o.name || o.realname || o.channel_name || "";
      return o.alias ? `${n}（${o.alias}）` : n;
    }
  }
};
</script>
<style lang="less" scoped>
.toolbar {
  margin-bottom: 12px;
}
.pagination {
  margin-top: 16px;
  text-align: right;
}
.muted {
  margin: 0 10px;
  color: #c0c4cc;
}
.danger {
  color: #f56c6c;
}
.invoice-upload {
  margin-top: 18px;
}
a {
  color: #409eff;
  text-decoration: none;
}
/deep/ .employee-highlight {
  color: red;
}
/deep/ .row-disabled {
  color: #c0c4cc;
}
/deep/ .row-highlight > td {
  background: #f56c6c !important;
}
/deep/ .row-credit > td {
  background: #c66cff !important;
}
/deep/ .row-colour-1 > td {
  background: #fffc00 !important;
}
/deep/ .row-colour-2 > td {
  background: #84e477 !important;
}
/deep/ .row-colour-4 > td {
  background: #c9c9c9 !important;
}
</style>
